import { createContext, Dispatch, useContext } from 'react'
import { EtsyListing } from '../../../../types/api/listings'
import { ChannelOnChangeHandler } from '../../../products_v5/components/JoinedForm/ChannelShared/SharedInputs'

interface EtsyChannelFormContextValues {
  errors: any
  form: EtsyListing
  onListingChange: ChannelOnChangeHandler
  templateForm: any // builder template form for possible autofill attributes
  localErrors: any
  setLocalErrors: Dispatch<any>
  productUnitTracking: boolean // whether the product has unit tracking enabled
}

export const EtsyChannelFormContext = createContext<EtsyChannelFormContextValues>({
  form: null,
  errors: null,
  onListingChange: (_e, _cb) => {},
  templateForm: null,
  localErrors: {},
  setLocalErrors: () => {},
  productUnitTracking: false
})
export const useEtsyChannelFormContext = () => useContext(EtsyChannelFormContext)
